import React from 'react';

const OpenLDAPHeroImage = () => {
  return (
    <div className="relative">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-500/20 to-green-500/20 rounded-lg"></div>
      <img
        src="https://images.unsplash.com/photo-1633265486064-086b219458ec?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80"
        alt="Identity Management"
        className="rounded-lg shadow-xl w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-gray-900/30 via-transparent to-transparent rounded-lg"></div>
    </div>
  );
};

export default OpenLDAPHeroImage;